export const SET_WIDGET_TITLE = 'SET_WIDGET_TITLE';
export const SET_PUBLISHERS = 'SET_PUBLISHERS';
export const SET_PUBLISHER = 'SET_PUBLISHER';
export const SET_PUBLISHER_REFERENCES = 'SET_PUBLISHER_CONFIG_REFERENCES';
export const SET_CHECK_REFERENCES_TEXT = 'SET_CHECK_REFERENCES_TEXT';
export const SET_USER_VISIBLE_COLUMNS = 'SET_USER_VISIBLE_COLUMNS';
export const SET_INVITES_FOR_PUBLISHER = 'setInvitesForPublisher';
export const SET_SHOW_NEW_PUBLISHER_INVITES = 'setShowNewPublisherInvites';
export const SET_ACCOUNT_SETTINGS = 'setAccountSettings';